<div class="section">
  <div class="row">
    <div class="col-12">
      <p class="section__title mb-0">{{ title }}</p>
      <div class="row">
        <div class="col-9">
          <div class="section__item">
            <p class="section__item-txt">
              {{ description }}
            </p>
            <p class="section__item-subtit">The Travelgate team.</p>
            @if (isBuyer) {
              <xen-btn
                class="d-block mt-4"
                [type]="'primary'"
                [size]="'large'"
                [label]="'Start API Implementation'"
                [icon]="true"
                [icon_placement]="'right'"
                [icon_snippet]="'far fa-angle-right'"
                [skin]="'gray'"
                (click)="submitFinish()"
              ></xen-btn>
            }
          </div>
        </div>
        <div class="col-3">
          <img class="img-fluid" src="assets/img/pages/onboarding/laptop.svg" alt="laptop" />
        </div>
      </div>
    </div>
  </div>
</div>
